'use strict';

// Set to true on SEO emergency
var __REVERT__ = false;

var _ = require('lodash');
var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined';
if (!isNode) {
    var DetectFlex = require('../../../../common-js/helpers').DetectFlex;
    if (!DetectFlex()) {
        var Flexibility = require('flexibility');
    }

    require('./footer.scss');
}

var Constants = require('../constants');
var Dialog = require('./dialog.jsx');
var Forms = require('../forms');
var Global = require('../global');
var RecentlyViewed = require('./recently-viewed.jsx');

const images = {
    Blog: require('../../../server/public/static/images/footer/Blog.png'),
    Facebook: require('../../../server/public/static/images/footer/Facebook.png'), 
    Twitter: require('../../../server/public/static/images/footer/Twitter.png'), 
    YouTube: require('../../../server/public/static/images/footer/YouTube.png'), 
    Pinterest: require('../../../server/public/static/images/footer/Pinterest.png')
}

var ResponsiveMixin = Global.ResponsiveMixin;

var FooterBlockText = React.createClass({
    componentDidMount: function() {
        if (Flexibility) {
            Flexibility(this.refs.block);
        }
    },
    open: function() {
        this.refs.dialog.open();
    },
    render__REVERT__: function() {
        return (
            <div className='ft-block' ref='block'>
                <h1 dangerouslySetInnerHTML={{__html: this.props.title }} />
                <div className='ft-blocktext' dangerouslySetInnerHTML={{__html: this.props.body }} />
            </div>
        );
    },
    render: function() {
        if (__REVERT__) {
            return this.render__REVERT__();
        }

        return (
            <div className='block' ref='block'>
                <p className="title" dangerouslySetInnerHTML={{__html: this.props.title }} />
                <div className='block-text' dangerouslySetInnerHTML={{__html: this.props.intro }} />

                <div className='block-button-flex-wrapper'>
                    <div className='block-button'>
                        <Forms.Button label='LEARN MORE' onClick={this.open} theme='dark' />
                    </div>
                </div>

                <Dialog ref='dialog' title={this.props.title} body={this.props.body} />

                <div style={{ display: 'none' }}>
                    {this.props.body}
                </div>
            </div>
        );
    }
});

var PageLinks = React.createClass({
    getInitialState: function() {
        return {
            expanded: __REVERT__,
        };
    },
    toggle: function() {
        this.setState({
            expanded: !this.state.expanded,
        });
    },
    render: function() {
        var master = Payload.footer.links[this.props.name];
        var short = _.slice(master, 0, 5);
        return (
            <div className="ft-pagelinks-block">
                <div className='ft-linkshead'>
                    {this.props.title}
                </div>
                <ul>
                    { (this.state.expanded ? master : short).map((link, ix) => {
                        return (
                            <li key={ix}>
                                {/* ID SET HERE - id={'ft-pagelink-' + ix} */}
                                <a href={link.url} target={this.props.title == 'SOCIAL' ? '_blank' : '_self'}>
                                    {this.props.title == 'SOCIAL' ?
                                        <img src={images[link.name]} alt={link.name} title={link.name} width="33" height="33" />
                                    : link.name}
                                </a>
                            </li>
                        );
                    })}
                    {master.length > short.length ?
                        <li>
                            <button onClick={this.toggle} dangerouslySetInnerHTML={{ __html:
                                this.state.expanded ? 'Less &mdash;' : 'More +'
                            }} />
                        </li>
                    : null}
                </ul>
            </div>
        );
    }
});

var Footer = React.createClass({
    mixins: [ ResponsiveMixin ],

    propTypes: {
        placeholder: React.PropTypes.bool,
    },
    getDefaultProps: function() {
        return {
            placeholder: false,
        };
    },
    renderDesktop: function() {
        return (
            <div>
                <RecentlyViewed />

                <div className='ft-copy'>
                    <FooterBlockText title = {Payload.footer.text['footer.block.0.title']}
                                     intro = {Payload.footer.text['footer.block.0.intro']}
                                     body  = {Payload.footer.text['footer.block.0.body']} />
                    <FooterBlockText title = {Payload.footer.text['footer.block.1.title']}
                                     intro = {Payload.footer.text['footer.block.1.intro']}
                                     body  = {Payload.footer.text['footer.block.1.body']} />
                </div>

                <div className='ft-links'>
                    <div className='ft-pagelinks'>
                        <PageLinks name='quick'    title='QUICK PRODUCT LINKS' />
                        <PageLinks name='info'     title='INFO' />
                        <PageLinks name='finance'  title='FINANCING' />
                        <PageLinks name='services' title='SERVICES' />
                        <PageLinks name='social'   title='SOCIAL' />
                    </div>
                </div>

                <div className='ft-legal'>
                    &copy; {new Date().getFullYear()} StrongProject Inc. &nbsp;/&nbsp;
                    <a href='/terms-of-service' className='fancybox-popup'>Terms and conditions</a> &nbsp;/&nbsp;
                    <a href='/office-furniture-dealer-los-angeles' id='ft-contact'>Contact us</a>
                </div>
            </div>
        );
    },
    renderMobile: function() {
        return (
            <div className='ft-mobile-bar'>
                &copy; {new Date().getFullYear()} StrongProject Inc. &nbsp;
                <div className='ft-tel'>
                    <a href={`tel:${Payload.header.text['header.phone.domestic.machine-readable']}`} id='ft-tel'>
                        {Payload.header.text['header.phone.domestic.human-readable']}
                    </a>
                </div>
            </div>
        );
    },
    render: function() {
        return (
            <div id='footer'>
                {this.props.placeholder ?
                    <div className='ft-placeholder' />
                :
                    this.state.viewportLayout == 'desktop' ? this.renderDesktop()
                                                            : this.renderMobile()
                }
            </div>
        );
    },
});

module.exports = Footer;



// WEBPACK FOOTER //
// ./src/components/footer.jsx